/**
 * IntelliGems A/B Test — Single shipping insurance
 *
 * Control (A): data-shipping-insurance-single="false"
 *   Current behaviour (control + sticky both preselected → 2x insurance).
 * Variant (B): data-shipping-insurance-single="true"
 *   Keep only 1 shipping insurance selected / in cart.
 *   Visible toggle stays ON when insurance is in the cart.
 *
 * Intelligems inject (Group 1):
 *   document.body.setAttribute('data-shipping-insurance-single', 'true');
 *
 * Dev: ?shipping_insurance_single_test=b
 */
(function () {
  'use strict';

  if (window.__shippingInsuranceSingleABTestInit) return;
  window.__shippingInsuranceSingleABTestInit = true;

  var BODY_ATTR = 'data-shipping-insurance-single';
  var STICKY_ATTR = 'data-cart-drawer-sticky';
  var INSURANCE_HANDLE = 'insured-shipping';
  var busy = false;
  var timer = null;
  var cartTimer = null;

  function isTruthy(value) {
    var n = String(value || '')
      .trim()
      .toLowerCase();
    return n === 'true' || n === '1' || n === 'on' || n === 'yes';
  }

  function isDevVariantB() {
    try {
      return (
        new URLSearchParams(window.location.search).get(
          'shipping_insurance_single_test'
        ) === 'b'
      );
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    var body = document.body;
    return !!(body && isTruthy(body.getAttribute(BODY_ATTR)));
  }

  function isStickyLayout() {
    var body = document.body;
    return !!(body && isTruthy(body.getAttribute(STICKY_ATTR)));
  }

  function applyDev() {
    if (!isDevVariantB() || !document.body) return;
    if (!isTruthy(document.body.getAttribute(BODY_ATTR))) {
      document.body.setAttribute(BODY_ATTR, 'true');
    }
  }

  function isInsuranceNode(el) {
    if (!el || !el.getAttribute) return false;
    if (el.getAttribute('data-shipping-insurance') === 'true') return true;
    if (el.classList && el.classList.contains('upsell--shipping-insurance')) {
      return true;
    }
    var handle = (el.getAttribute('data-handle') || '').toLowerCase();
    var titleEl = el.querySelector && el.querySelector('.upsell__title h3');
    var titleText = titleEl ? (titleEl.textContent || '').toLowerCase() : '';
    return (
      handle === INSURANCE_HANDLE ||
      handle.indexOf('insured') !== -1 ||
      handle.indexOf('insurance') !== -1 ||
      handle === 'only-shipping' ||
      titleText.indexOf('shipping insurance') !== -1
    );
  }

  function isStickyInsurance(el) {
    if (!el) return false;
    if (el.getAttribute('data-shipping-insurance') === 'true') return true;
    if (el.classList && el.classList.contains('upsell--shipping-insurance')) {
      return true;
    }
    var wrap = el.closest('[data-upsell-mode]');
    return !!(wrap && wrap.getAttribute('data-upsell-mode') === 'sticky');
  }

  function isInsuranceCartItem(item) {
    if (!item) return false;
    var handle = String(item.handle || '').toLowerCase();
    var title = String(
      item.product_title || item.title || ''
    ).toLowerCase();
    return (
      handle === INSURANCE_HANDLE ||
      handle.indexOf('insured') !== -1 ||
      handle.indexOf('insurance') !== -1 ||
      handle === 'only-shipping' ||
      title.indexOf('shipping insurance') !== -1
    );
  }

  function getDrawer() {
    return (
      document.querySelector('#CartDrawer') ||
      document.querySelector('cart-drawer')
    );
  }

  function getInsuranceNodes(drawer) {
    if (!drawer) return [];
    return Array.prototype.slice
      .call(
        drawer.querySelectorAll(
          'cart-drawer-upsell[data-toggle="true"], cart-drawer-upsell.upsell, .upsell[data-handle]'
        )
      )
      .filter(isInsuranceNode);
  }

  /**
   * Pick the insurance upsell that matches the active cart-drawer layout.
   * Do NOT use getClientRects — drawer may be closed and every node looks "hidden",
   * which previously kept the sticky (CSS-hidden) copy selected and turned the
   * visible control toggle OFF while insurance stayed in the cart.
   */
  function pickKeeper(nodes) {
    if (!nodes.length) return null;

    var stickyOn = isStickyLayout();
    var i;

    if (stickyOn) {
      for (i = 0; i < nodes.length; i++) {
        if (isStickyInsurance(nodes[i])) return nodes[i];
      }
    } else {
      for (i = 0; i < nodes.length; i++) {
        if (!isStickyInsurance(nodes[i])) return nodes[i];
      }
    }

    return nodes[0];
  }

  function selectNode(el) {
    if (!el) return;
    el.setAttribute('data-selected', 'true');
    if (el.dataset) el.dataset.selected = 'true';
  }

  function deselectNode(el) {
    if (!el) return;
    el.setAttribute('data-selected', 'false');
    if (el.dataset) el.dataset.selected = 'false';
  }

  /**
   * @param {boolean|undefined} cartHasInsurance
   *   true  → force visible keeper ON (insurance is in cart)
   *   false → leave keeper as-is (only strip duplicate selected copies)
   *   undefined → same as false (DOM-only dedupe)
   */
  function syncUpsellSelection(cartHasInsurance) {
    var drawer = getDrawer();
    var nodes = getInsuranceNodes(drawer);
    if (!nodes.length) return null;

    var keeper = pickKeeper(nodes);
    if (!keeper) return null;

    nodes.forEach(function (node) {
      if (node === keeper) {
        if (cartHasInsurance === true) selectNode(node);
      } else {
        deselectNode(node);
      }
    });

    return keeper;
  }

  function refreshCartUi(cart) {
    try {
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: cart },
          bubbles: true,
        })
      );
    } catch (e) {}
    try {
      document.dispatchEvent(
        new CustomEvent('cart-drawer:updated', {
          detail: { cart: cart },
          bubbles: true,
        })
      );
    } catch (e) {}
  }

  function insuranceQty(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (isInsuranceCartItem(item) ? item.quantity || 0 : 0);
    }, 0);
  }

  function syncFromCart() {
    if (busy) return Promise.resolve();
    busy = true;

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js failed');
        return res.json();
      })
      .then(function (cart) {
        var qty = insuranceQty(cart);
        var hasInsurance = qty >= 1;

        syncUpsellSelection(hasInsurance);

        if (qty <= 1) return null;

        var insurance = (cart.items || []).filter(isInsuranceCartItem);
        var updates = {};
        insurance.forEach(function (item, index) {
          updates[item.key] = index === 0 ? 1 : 0;
        });

        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ updates: updates }),
        }).then(function (res) {
          if (!res.ok) throw new Error('cart/update.js failed');
          return res.json();
        });
      })
      .then(function (cart) {
        if (cart) {
          syncUpsellSelection(insuranceQty(cart) >= 1);
          refreshCartUi(cart);
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  }

  function run() {
    applyDev();
    if (!isVariantB()) return;

    /* DOM-only: deselect hidden duplicate; don't force keeper yet */
    syncUpsellSelection();

    window.clearTimeout(cartTimer);
    cartTimer = window.setTimeout(function () {
      if (!isVariantB()) return;
      syncFromCart();
    }, 80);
  }

  function scheduleRun() {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, 60);
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('cart:updated', scheduleRun);
  document.addEventListener('cart-drawer:updated', scheduleRun);
  document.addEventListener('ajax:cart:updated', scheduleRun);

  if (document.body) {
    new MutationObserver(function (mutations) {
      var i;
      for (i = 0; i < mutations.length; i++) {
        if (
          mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === STICKY_ATTR
        ) {
          scheduleRun();
          return;
        }
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, STICKY_ATTR],
    });
  }

  var root = document.querySelector('cart-drawer');
  if (root && window.MutationObserver) {
    new MutationObserver(function () {
      if (!isVariantB()) return;
      scheduleRun();
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.body) applyDev();
  run();
})();
